<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table table-bordered off-board">
        <thead>
        <tr>
          <th>Name</th>
          <th>Off Boarding Type</th>
          <th>Details Reason</th>
          <th>Application Date</th>
          <th>Last Working Date</th>
          <th>Attachment</th>
          <th>Remarks</th>
          <th>Status</th>
          <th>Recommendation</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td>{{ item.contact_profile_name }}</td>
          <td>{{ item.off_boarding_type }}</td>
          <td>{{ item.details_reason }}</td>
          <td>{{ item.created_at_formatted }}</td>
          <td>{{ item.last_working_date_formatted }}</td>
          <td>
            <button v-if="item.employee_off_boarding.attachments.length > 0" class="btn btn-primary btn-sm"
                    style="cursor: pointer"
                    @click="viewAttachments(item.employee_off_boarding.attachments)"
            >
              <i class="fas fa-eye"></i>
              View
            </button>
            <span v-else class="badge btn-danger">
               No attachments
            </span>
          </td>
          <td>{{ item.remarks }}</td>
          <td>{{ item.status }}</td>
          <td>
            <span class="text-capitalize">{{ item.recommendation_type }}</span>
          </td>
          <td>
            <button v-if="['recommend'].includes(item.recommendation_type) && item.status != 'approved'"
                    class="btn btn-primary btn-sm"
                    @click="openModal(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
           </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>

    <ViewAttachment
        ref="viewAttachmentRef"
        :attachments="modalAttachments"
    />

    <RecommendUserApprovalModal
        v-if="store.state.isModalOpen"
        :formData="formData"
        @getOffBoardingList="getOffBoardingList"
    />

  </div>
</template>

<script setup>
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import RecommendUserApprovalModal from '@/components/molecule/company/hrm-payroll/employee-off-boarding/RecommendUserApprovalModal.vue';
import {ref} from "vue";
import ViewAttachment from '@/views/page/company/ngo/voucher/payment/ViewAttachmentModal.vue'

const props  = defineProps({
  tableItems     : Object,
  getOffBoardingList:{
    type:Function
  },
});
const store = useStore();
const route = useRoute();
const modalAttachments = ref([]);
const viewAttachmentRef = ref();

const {
  fetchSingleEmployeeOffBoardingApprovalAssignUser
} = handleHrPayroll()

const viewAttachments = (attachments) => {
  modalAttachments.value = [];
  modalAttachments.value = attachments;
  viewAttachmentRef.value && viewAttachmentRef.value.toggleModal();
}

const formData = ref({
  employee_off_boarding_log_id:null,
  remarks: null,
})

const openModal = (item) => {
  store.state.isModalOpen = true
  let query = `?company_id=${route.params.companyId}`;
  fetchSingleEmployeeOffBoardingApprovalAssignUser(item.id, query).then(res => {
    if (!res.status){
      return
    }

    formData.value.employee_off_boarding_log_id = res.data.id;
    formData.value.remarks = res.data.remarks;
  });
}

</script>

